<template>
  <v-data-table
    class="mt-5 products-table"
    no-data-text="Nenhum produto encontrado"
    :hide-default-footer="items.length < 10"
    :items-per-page="10"
    :headers="headers"
    :items="items"
    :loading="loading"
    :options.sync="computedOptions"
  >
    <template v-slot:item.productName="{ item }">
      <div class="ellipsis-container">
        <mf-tooltip max-width="250" top>
          <template v-slot:activator>
            <div class="hidden">hidden</div>
            <span class="ellipsis-td link" @click="openProduct(item.sku)">
              {{ item.productName }}
            </span>
          </template>
          {{ item.productName }}
        </mf-tooltip>
      </div>
    </template>

    <template v-if="variant === 'analysis'" v-slot:item.currentRevenue="{ item }">
      <mf-stonks variant="percentage" show-value :percentage="item.percentage" :value="item.currentRevenue" />
    </template>

    <template v-slot:item.potentialRevenue="{ item }">
      <mf-stonks variant="potential" show-inconclusive-tooltip :value="item.potentialRevenue" />
    </template>

    <template v-slot:item.action="{ item }">
      <mf-tooltip v-if="variant === 'analysis'" top>
        <template v-slot:activator>
          <mf-button :disabled="loading" type="icon" icon="cancel" color="vermelho-d20" @click="removeOpportunity(item.sku)" />
        </template>
        Remover oportunidade
      </mf-tooltip>

      <mf-button v-else :disabled="loading" text color="marca-0-l40" icon="upgrade" label="Analisar produto" @click="analyseOpportunity" />
    </template>
  </v-data-table>
</template>

<script>
import { putEllipsis } from '@/config/helpers.js'
import MfStonks from './MfStonks.vue'
export default {
  name: 'ProductsTable',
  components: {
    MfStonks,
  },
  props: {
    variant: {
      type: String,
      required: true,
      validator: (value) => ['analysis', 'suggests'].includes(value),
    },
    products: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    charCount: 12,
  }),
  computed: {
    computedOptions: {
      get() {
        return this.options
      },
      set(value) {
        this.$emit('update:options', value)
      },
    },
    items() {
      if (this.variant === 'analysis') {
        return this.products.map((product) => {
          const currentValue = (product.currentRevenue * 100) / product.referenceRevenue
          const percentage = currentValue - 100 || 0

          return {
            ...product,
            percentage,
          }
        })
      } else return []
    },
    headers() {
      if (this.variant === 'analysis') {
        return [
          {
            text: 'Produtos',
            value: 'productName',
            width: 'auto',
            sortable: false,
          },
          {
            text: 'Faturamento atual',
            value: 'currentRevenue',
            width: '230px',
            sortable: false,
          },
          {
            text: 'Ganho potencial',
            value: 'potentialRevenue',
            width: '150px',
            sortable: false,
          },
          {
            text: '',
            value: 'action',
            width: '40px',
            sortable: false,
            align: 'right',
          },
        ]
      } else {
        return [
          {
            text: 'Produtos',
            value: 'productName',
            width: '40%',
            sortable: false,
          },
          {
            text: 'Ganho potencial',
            value: 'potentialRevenue',
            width: '160px',
            sortable: false,
          },
          {
            text: '',
            value: 'action',
            width: '',
            sortable: false,
            align: 'right',
          },
        ]
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  methods: {
    putEllipsis,
    onResize() {
      const container = document.querySelector('td.text-start')
      if (!container) this.charCount = 12
      else {
        const width = container.clientWidth
        this.charCount = width / 13
      }
    },
    openProduct(sku) {
      const url = `/produtos/detalhes-produto/${sku}`
      const routeURL = this.$router.resolve({ path: url }).href

      window.open(routeURL, '_blank')
    },
    async removeOpportunity(sku) {
      const confirmed = await this.$confirm({
        title: 'Remover oportunidade',
        message: 'Tem certeza que deseja remover esse produto da análise? Essa ação impactará nos produtos presentes da Estratégia de impulsionamento.',
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.$emit('remove-product', sku)
    },
    analyseOpportunity() {},
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table__wrapper {
  overflow-x: hidden !important;
}
.v-data-table {
  background-color: transparent !important;
}
.ellipsis-container {
  position: relative;
}
.hidden {
  visibility: hidden;
}
.ellipsis-td {
  max-width: calc(100%);
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep th {
  color: $cinza-d20 !important;
  font-size: 14px;
  font-weight: bold;
}

::v-deep td,
::v-deep th {
  padding: 0 12px;
}

::v-deep tbody {
  td {
    color: $cinza-0;
    font-size: 14px;
    line-height: 1;
  }
}

::v-deep .v-data-footer__select {
  display: none;
}
</style>
